// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".payment-result__image[data-v-0a5dc7e5]{text-align:center}.payment-result__image img[data-v-0a5dc7e5]{width:100%}.payment-result__title[data-v-0a5dc7e5]{margin-top:-10px;text-align:justify;white-space:pre-line;font-style:normal;font-weight:400;font-size:18px;line-height:24px}.payment-result__description[data-v-0a5dc7e5]{margin-top:8px;font-style:normal;font-weight:400;font-size:16px;line-height:22px}.payment-result__details[data-v-0a5dc7e5]{margin-top:28px}", ""]);
// Exports
module.exports = exports;
